import React from 'react';
import './About.css';
import Header from './Header';
import Footer from './Footer';

const About = () => {
    return (
        <>
            <Header />
            <main className="about-container">
                <section className="about-section">
                    <h1 className="about-title">About <span>Digital Journaling</span></h1>
                    <p className="about-description">
                        Welcome to <strong>Digital Journaling</strong> — your space for insightful articles, 
                        fresh perspectives, and meaningful stories. We cover a wide range of topics from 
                        <em> technology</em> to <em>lifestyle</em>, designed to keep you informed, inspired, 
                        and motivated.
                    </p>
                </section>

                <section className="about-section">
                    <h2 className="about-subtitle">Our Mission</h2>
                    <p>
                        At Digital Journaling, we believe in the <strong>power of words and ideas</strong>. 
                        Our mission is to build a platform where creativity meets knowledge, 
                        empowering readers to explore, learn, and grow every day.
                    </p>
                </section>

                <section className="about-section">
                    <h2 className="about-subtitle">Our Vision</h2>
                    <p>
                        We aim to create a <em>community of curious minds</em> who value 
                        thoughtful content. Whether you’re here for <strong>journaling tips</strong>, 
                        <strong>tech insights</strong>, or <strong>personal growth stories</strong>, 
                        you’ll always find something that resonates with you.
                    </p>
                </section>

                <section className="about-section">
                    <h2 className="about-subtitle">Join Us</h2>
                    <p>
                        This is more than just a blog — it’s a journey of discovery and 
                        self-expression. Share your thoughts, suggestions, or even your 
                        own stories with us. Together, let’s make Digital Journaling a 
                        hub of <strong>inspiration and connection</strong>.
                    </p>
                </section>
            </main>
            <Footer />
        </>
    );
};

export default About;
